import React, { Component } from 'react';
import {Redirect} from "react-router-dom";
import FlatButton from "material-ui/FlatButton";
import TextField from 'material-ui/TextField/TextField';
import {Card, CardActions} from "material-ui/Card";
import {NavigationArrowBack} from "material-ui/svg-icons";

import * as utils from './utils';
import * as urls from "./urls";
import ViewTitle from "components/layout/ViewTitle";
import connect from "react-redux/es/connect/connect";

import { extendMembershipGet, extendMembershipUpdate } from 'actions/advancedFunction';
import {NumberInput} from "components/input";
import ExploreIcon from "material-ui/svg-icons/action/explore";
import {SimpleForm} from "components/form";
import { setSaving, showNotification } from "actions";

const cardActionStyle = {
  zIndex: 2,
  float: 'right',
};
class ExtendMembershipUpdate extends Component {
  constructor(props) {
    super(props);
    this.goBack = this.goBack.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
      const {currentSelectedShopData} = this.props;
      if (currentSelectedShopData) {
          this.props.dispatch(extendMembershipGet(currentSelectedShopData.shop_id));
      }
  }

  goBack() {
    this.props.history.goBack();
  }

  handleSubmit(record) {
    const {currentSelectedShopData} = this.props;
    if (record.new_member_count_limit <= currentSelectedShopData.membership_info.total_member) {
      this.props.dispatch(showNotification('New member count limit must be greater than the current total member', 'warning'));
      this.props.dispatch(setSaving(false));
      return ;
    }
    const data = {
      shop_id: currentSelectedShopData.shop_id,
      new_member_count_limit: record.new_member_count_limit
    };
    this.props.dispatch(extendMembershipUpdate(data));
  }

  render() {
    const {currentSelectedShopData} = this.props;
    if (!currentSelectedShopData) {
      return (
        <Redirect to={urls.extendMembershipFrontendPath} />
      );
    }

    return (
      <div className="list-page">
        <Card style={ {padding: '5px'} }>
          <CardActions style={cardActionStyle} >
            <FlatButton primary label={'Back'}
                        onClick={this.goBack}
                        icon={ <NavigationArrowBack />}
            />
          </CardActions>
          <ViewTitle title='Membership extension' />

          <div style={{padding: '20px'}}>
            <TextField floatingLabelText={'Chain ID'} value={currentSelectedShopData.membership_info.chain_id} />
            <br />
            <TextField floatingLabelText={'Shop ID'} value={currentSelectedShopData.shop_id}/>
            <br />
            <TextField floatingLabelText={'Shop Name'} value={currentSelectedShopData.shop_info.shop_name}/>
            <br />
            {
                <SimpleForm submitButtonIcon={<ExploreIcon/>}
                            submitButtonLabel="Inquiry"
                            onSubmit={this.handleSubmit}
                >
                  <NumberInput 
                    isRequired={true}
                    source='new_member_count_limit'
                    label={'New member count limit'}
                  />
                </SimpleForm>
            }
          </div>
        </Card>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    currentSelectedShopData: state.admin.recordSelected[utils.ExtendMembershipResourceName],
  };
}

export default connect( mapStateToProps )(ExtendMembershipUpdate);



// WEBPACK FOOTER //
// ./src/routes/advancedFunction/ExtendMembershipUpdate.js